import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../Subcomponents/Button";
import Datagrid from "../../Subcomponents/Datagrid";
import SearchBar from "../../Subcomponents/Search";
import AddIcon from "@mui/icons-material/Add";
import DropDown from "./../../Subcomponents/DropDown";

// css
import cssClasses from "./SelectToken.module.css";
import { Checkbox } from "@mui/material";

function SelectToken({ allChildRows, deSelectAll, selectAll, columns, rows, pageChanged, setSearchToken }) {
  const navigate = useNavigate();
  return (
    <div className={cssClasses.mainContainer}>
      <div className={cssClasses.content}>
        <div className={cssClasses.actionWrapper}>
          {/* <div className={cssClasses.leftActionWrapper}>
            <div className={cssClasses.filterWrapper}>
              <div className={cssClasses.label}>
                <p>Filter by</p>
              </div>
              <div className={cssClasses.dropdownWrapper}>
                <DropDown
                  style={{
                    selectedColor: "#175CD3",
                    background: "#E8F0FE",
                  }}
                  selectedValue={token.validity}
                  onChangeSelect={(e) => {
                    console.log(e);
                    setToken({ ...token, validity: e });
                  }}
                  list={["All", "Live", "Upcoming", "Closed"]}
                />
              </div>
            </div>
          </div> */}
          <div className={cssClasses.rightActionWrapper}>
            <div className={cssClasses.searchWrapper}>
              <SearchBar
                id={'abc'}
                placeholder={"Search by token name"}
                search={(e) => {
                  setSearchToken(e.target.value);
                }}
              //   id={id}
              />
            </div>
            <div style={{
              display: 'flex',
              fontSize: '1.4rem',
              gap: "2rem"
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center'
              }}>
                <Checkbox style={{ width: "1.4rem", height: "1.4rem" }} checked={allChildRows?.filter((e) => { return e.isSelected === true }).length === allChildRows?.length ? true : false} onChange={selectAll} />
                <p onClick={selectAll} style={{ cursor: "pointer" }}>Select All</p>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center'
              }}>
                <Checkbox style={{ width: "1.4rem", height: "1.4rem" }} checked={allChildRows?.filter((e) => { return e.isSelected === false }).length === allChildRows?.length ? true : false} onChange={deSelectAll} />
                <p onClick={deSelectAll} style={{ cursor: "pointer" }}>Deselect All</p>
              </div>
            </div>
            {/* <div className={cssClasses.btnWrapper}>
              <Button
                clicked={() => {
                  navigate("/home/Token");
                }}
                btnName={"Add New Token"}
                btnIcon={<AddIcon style={{ width: "2rem", height: "2rem" }} />}
                style={{
                  borderRadius: "0.4rem",
                  backgroundColor: "#1570EF",
                  color: "#FFFFFF",
                  fontSize: "1.6rem",
                }}
                padding={"0.5rem 1rem"}
                iconPosition={"left"}
              />
            </div> */}
          </div>
        </div>
        <div className={cssClasses.gridWrapper}>
          <Datagrid
            pageChanged={pageChanged}
            hideFooter={false}
            columns={columns}
            rows={rows}
          />
        </div>
      </div>
    </div>
  );
}

export default SelectToken;
